import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Breadcrumbs as MuiBreadcrumbs,
  Typography,
  Link
} from '@mui/material';
import {
  Home as HomeIcon,
  NavigateNext as NavigateNextIcon,
  Settings as SettingsIcon,
  Print as PrintIcon
} from '@mui/icons-material';

const NavigationBreadcrumbs = ({ currentPage }) => {
  const navigate = useNavigate();

  return (
    <MuiBreadcrumbs 
      separator={<NavigateNextIcon fontSize="small" />} 
      aria-label="breadcrumb"
      sx={{ mb: 3 }}
    >
      <Link 
        color="inherit" 
        onClick={(e) => {
          e.preventDefault();
          navigate('/dashboard');
        }}
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          textDecoration: 'none',
          color: 'text.primary',
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
          }
        }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        Dashboard
      </Link>
      <Link 
        color="inherit" 
        onClick={(e) => {
          e.preventDefault();
          navigate('/configuracoes');
        }}
        sx={{ 
          display: 'flex', 
          alignItems: 'center',
          textDecoration: 'none',
          color: 'text.primary',
          cursor: 'pointer',
          '&:hover': {
            textDecoration: 'underline',
          }
        }}
      >
        <SettingsIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        Configurações
      </Link>
      
      {currentPage === 'aparencia' && (
        <Link 
          color="inherit" 
          onClick={(e) => {
            e.preventDefault();
            navigate('/aparencia');
          }}
          sx={{ 
            display: 'flex', 
            alignItems: 'center',
            textDecoration: 'none',
            color: 'text.primary',
            cursor: 'pointer',
            '&:hover': {
              textDecoration: 'underline',
            }
          }}
        >
          Aparência
        </Link>
      )}
      
      {currentPage === 'impressora' && (
        <>
          <Typography color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
            <PrintIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            Impressão de Tickets
          </Typography>
        </>
      )}
    </MuiBreadcrumbs>
  );
};

export default NavigationBreadcrumbs; 